import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import buscarBlanco from '../../../img/navbar/icon_buscar_blanco.svg'
import { errorSwal } from '../../../helper/swalHelpers';
import { Redirect, useParams } from "react-router";
import './navbar.css'

const SearchMenu = ({  }) => {
    const [redireccionar, setRedireccionar] = useState(undefined);
    const [busqueda, setBusqueda] = useState("");

    const handleChange = (e) => {
        setBusqueda(e.target.value)
    }

    const realizarBusqueda = async () => {
        try {
            if(busqueda) {
                setRedireccionar({
                    pathname: "/buscar",
                    state: {
                        palabraBuscar: busqueda,
                    },
                });
                
            }
        } catch (error) {
            errorSwal("Ocurrió un error", "Vuelve a intentarlo más tarde", "Volver a intentar");
        }
    }

    const handleBuscar = () => {
        if (busqueda && busqueda.length >= 3) {
            realizarBusqueda();
            return;
        }
        errorSwal("Ocurrió un error", "Debes ingresar al menos 3 caracteres para realizar una búsqueda.", "Volver a intentar");
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleBuscar();
    }

    if (redireccionar) return <Redirect to={redireccionar} />;

    return (
        <Input 
            bordered={false} 
            prefix={<img src={buscarBlanco}/>} 
            className="input-search" 
            placeholder="Realizar búsqueda" 
            onChange={handleChange} 
            onKeyDown={handleKeyDown} 
            type="search"
        />
    );
}

export default SearchMenu;